module.exports = __webpack_public_path__ + "static/media/2017-22-hn.b048438d.png";